// components/Loader.tsx
import React from "react";
import "../style/css/Loader.css";

interface LoaderProps {
  show?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ show = true }) => {
  return (
    <div className={`agenda-loader ${show ? "" : "hidden"}`}>
      <div className="loader-circle"></div>
      <p className="loader-text">Cara de agenda</p>
    </div>
  );
};

export default Loader;
